import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild, HostListener } from '@angular/core';
import { CommonWebService, SnackbarEnum } from "apps/website/src/app/utils/public-api";
import { environment } from 'apps/website/src/environments/environment';
import Swal from 'sweetalert2';
@Component({
  selector: 'intrasense-table-pagination',
  templateUrl: './table-pagination.component.html',
  styleUrls: ['./table-pagination.component.scss']
})
export class TablePaginationComponent implements OnInit {
  @Input() currentPage: number = 1;
  @Input() totalRecords: number = 0;
  @Input() offset: number = 0;
  @Input() limit: number = 0;
  @Output() pageChange = new EventEmitter<number>();
  @ViewChild('pageInput') pageInput!: ElementRef;
  isSmallScreen = window.innerWidth < 767;
  itemsPerPage = environment.itemsPerPage;
  //@Output() limitRecordsPerPage = new EventEmitter<number>();


  constructor(private commonService: CommonWebService) { }

  ngOnInit(): void {
    this.updateScreenSize();
  }

  get totalPages(): number {
    return (Math.ceil(this.totalRecords / this.limit));//the page number offset is starting from 0 in the backend
  }

  get currentGroup(): number {
    return Math.floor((this.currentPage - 1) / 10);
  }

  get visiblePages(): number[] {
    const pageSize = this.isSmallScreen ? 5 : 10;
    const start = this.currentGroup * pageSize + 1;
    const end = Math.min(start + pageSize - 1, this.totalPages);
    const pages: number[] = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }

  get hasPreviousGroup(): boolean {
    return this.currentGroup > 0;
  }

  get hasNextGroup(): boolean {
    return (this.currentGroup + 1) * 10 < this.totalPages;
  }

  changePage(page: number): void {
    if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
      this.currentPage = page;
      this.pageChange.emit(page - 1); // Emit zero-based index for backend
    }
  }

  goToPreviousGroup(): void {
    const page = (this.currentGroup - 1) * 10 + 1;
    this.changePage(page);
  }

  goToNextGroup(): void {
    const page = (this.currentGroup + 1) * 10 + 1;
    this.changePage(page);
  }

  goToPage(): void {
    const value = parseInt(this.pageInput.nativeElement.value, 10);
    if (!isNaN(value) && value >= 1 && value <= this.totalPages) {
      this.changePage(value);
    } else if (value > this.totalPages) {
      this.commonService.openSnackbar("The page number should be less than " + this.totalPages, SnackbarEnum.ERROR);
      //alert('The number you have entered is more than the total number of pages. Please input a valid number.')
    }
    this.pageInput.nativeElement.value = '';
  }

  @HostListener('window:resize')
  onResize() {
    this.updateScreenSize();
  }

  updateScreenSize() {
    this.isSmallScreen = window.innerWidth < 767;
  }
}
